import { color } from 'chart.js/helpers';

import { THEME } from '../constants';
import { getResonanceChartBaseColors } from './chart';

const formatLinksToStackedHorizontalBarChartData = (
  data,
  theme = THEME.DARK,
  isGlobalPercentage = false,
  labelsSelector,
) => {
  const BASE_COLORS = getResonanceChartBaseColors(theme);

  return {
    labels: data.map(labelsSelector),
    datasets: [
      {
        label: 'R1',
        backgroundColor: color(BASE_COLORS.BLUE).rgbString(),
        borderWidth: 0,
        barThickness: 14,
        data: data.map((link) => (isGlobalPercentage ? link.globalR1 : link.r1 || null)),
      },
      {
        label: 'R2',
        backgroundColor: color(BASE_COLORS.GREEN).rgbString(),
        borderWidth: 0,
        barThickness: 14,
        data: data.map((link) => (isGlobalPercentage ? link.globalR2 : link.r2 || null)),
      },
    ],
  };
};

export default formatLinksToStackedHorizontalBarChartData;
